'use client';

import { useEffect } from 'react';
import { usePathname, useSearchParams } from 'next/navigation';
import { sanitizePagePath, trackPageView } from '@/lib/analytics/siteAnalytics';

/**
 * Pushes one `page_view` per distinct URL to the GTM dataLayer (initial load and
 * client-side navigations). Queued events only reach Google after consent.
 * Render inside <Suspense> (useSearchParams).
 */
export function PageViewTracker() {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const search = searchParams?.toString() ?? '';

  useEffect(() => {
    if (!pathname) return;
    trackPageView(sanitizePagePath(pathname, search), document.title);
  }, [pathname, search]);

  return null;
}
